import { takeEvery, takeLatest, takeLeading } from 'redux-saga/effects';
import {
  AUTHORIZED_CHECK,
  AUTHORIZED_LOGIN,
  AUTHORIZED_LOGOUT,
  AUTHORIZED_REFRESH,
  AUTHORIZED_REGISTRATION, DELETE_NOTIFICATION,
  FORGOT_PASSWORD,
  LOAD_NOTIFICATION,
  MARK_ALL,
  UPDATE_PASSWORD,
} from '../actions';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';

import authorizedCheck from './authorizedCheck';
import authorizedLogin from './authorizedLogin';
import authorizedLogout from './authorizedLogout';
import authorizedRefresh from './authorizedRefresh';
import authorizedRegistration from './authorizedRegistration';
import forgotPassword from './forgotPassword';
import updatePassword from './updatePassword';
import loadNotification from './loadNotification';
import deleteNotification from './deleteNotification';
import markAllNotification from './markAllNotification';

export default function* watchClient() {
  yield takeEvery(AUTHORIZED_MODULE + MARK_ALL, markAllNotification);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_REGISTRATION, authorizedRegistration);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_LOGIN, authorizedLogin);
  yield takeLeading(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT, authorizedLogout);
  yield takeLatest(AUTHORIZED_MODULE + AUTHORIZED_REFRESH, authorizedRefresh);
  yield takeLatest(AUTHORIZED_MODULE + AUTHORIZED_CHECK, authorizedCheck);
  yield takeEvery(AUTHORIZED_MODULE + FORGOT_PASSWORD, forgotPassword);
  yield takeEvery(AUTHORIZED_MODULE + UPDATE_PASSWORD, updatePassword);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_NOTIFICATION, loadNotification);
  yield takeEvery(AUTHORIZED_MODULE + DELETE_NOTIFICATION, deleteNotification);
}
